import { render, staticRenderFns } from "./athlete-registration-pdf.vue?vue&type=template&id=2f3dc1f7&scoped=true&"
import script from "./athlete-registration-pdf.vue?vue&type=script&lang=js&"
export * from "./athlete-registration-pdf.vue?vue&type=script&lang=js&"
import style0 from "./athlete-registration-pdf.vue?vue&type=style&index=0&id=2f3dc1f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3dc1f7",
  null
  
)

export default component.exports